/* Storefront behaviour. Vanilla, no dependencies. */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function formatMoney(cents) {
    var fmt = (window.moneyFormat || '{{amount_no_decimals_with_comma_separator}} kr').replace(/<[^>]*>/g, '');
    var value = cents / 100;

    function group(str, sep) {
      return str.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, token) {
      switch (token) {
        case 'amount_no_decimals':
          return group(String(Math.round(value)), ',');
        case 'amount_with_comma_separator':
          return group(Math.floor(value).toString(), '.') + ',' + value.toFixed(2).split('.')[1];
        case 'amount_no_decimals_with_comma_separator':
          return group(String(Math.round(value)), '\u00a0');
        case 'amount_no_decimals_with_space_separator':
          return group(String(Math.round(value)), '\u00a0');
        case 'amount_with_space_separator':
          return group(Math.floor(value).toString(), '\u00a0') + ',' + value.toFixed(2).split('.')[1];
        default:
          return group(Math.floor(value).toString(), ',') + '.' + value.toFixed(2).split('.')[1];
      }
    });
  }

  /* ----------------------------------------------------------------------
     Announcement rotator
     ---------------------------------------------------------------------- */
  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar) return;
    var slides = $$('.announcement__slide', bar);
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, parseInt(bar.dataset.speed, 10) || 4000);
  }

  /* ----------------------------------------------------------------------
     Mobile navigation
     ---------------------------------------------------------------------- */
  function initMobileNav() {
    var nav = $('[data-mobile-nav]');
    if (!nav) return;
    function open() {
      nav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      nav.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    $$('[data-nav-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-nav-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ----------------------------------------------------------------------
     Cart drawer
     ---------------------------------------------------------------------- */
  /* ----------------------------------------------------------------------
     Cart drawer

     Uses Shopify's Section Rendering API so the whole panel — prices,
     shipping gauge, series rack — is rebuilt server-side on every change.
     No money formatting in JS, no state drift.
     ---------------------------------------------------------------------- */
  var SECTION = 'cart-drawer';

  var Cart = {
    el: null,
    lastFocus: null,

    init: function () {
      Cart.el = $('#CartDrawer');
      if (!Cart.el) return;

      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-close]')) {
          e.preventDefault();
          Cart.close();
          return;
        }
        if (e.target.closest('[data-cart-open]')) {
          e.preventDefault();
          Cart.open();
          return;
        }
        var change = e.target.closest('[data-line-change]');
        if (change && Cart.el.contains(change)) {
          e.preventDefault();
          Cart.change(change.dataset.lineKey, parseInt(change.dataset.lineChange, 10), change);
          return;
        }
        var quick = e.target.closest('[data-quick-add]');
        if (quick && Cart.el.contains(quick)) {
          e.preventDefault();
          Cart.quickAdd(quick.dataset.quickAdd, quick);
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && Cart.isOpen()) Cart.close();
        if (e.key === 'Tab' && Cart.isOpen()) Cart.trapFocus(e);
      });

      Cart.bindNote();
    },

    isOpen: function () {
      return Cart.el && Cart.el.classList.contains('is-open');
    },

    open: function () {
      Cart.lastFocus = document.activeElement;
      Cart.el.classList.add('is-open');
      Cart.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      var close = $('[data-cart-close]', Cart.el);
      if (close) close.focus();
    },

    close: function () {
      if (!Cart.el) return;
      Cart.el.classList.remove('is-open');
      Cart.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      if (Cart.lastFocus) Cart.lastFocus.focus();
    },

    trapFocus: function (e) {
      var focusables = $$(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
        Cart.el
      ).filter(function (el) { return el.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    },

    busy: function (state) {
      Cart.el.classList.toggle('is-busy', state);
    },

    /* Swap in freshly rendered markup and refresh the header bubble. */
    render: function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-cart-drawer-content]');
      var current = $('[data-cart-drawer-content]', Cart.el);
      if (!next || !current) return;

      current.innerHTML = next.innerHTML;

      var countEl = $('[data-cart-total-count]', Cart.el);
      var count = countEl ? parseInt(countEl.textContent.trim(), 10) : 0;
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });

      Cart.bindNote();
    },

    bindNote: function () {
      var note = $('[data-cart-note]', Cart.el);
      if (!note) return;
      var timer;
      note.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          fetch(window.routes.cart + '/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: note.value })
          });
        }, 600);
      });
    },

    handleError: function (err) {
      var msg = (err && err.description) || (err && err.message) || window.themeStrings.cartError;
      var body = $('.drawer__body', Cart.el) || Cart.el;
      var existing = $('.drawer__error', Cart.el);
      if (existing) existing.remove();
      var box = document.createElement('p');
      box.className = 'drawer__error';
      box.setAttribute('role', 'alert');
      box.textContent = msg;
      body.prepend(box);
    },

    change: function (key, quantity, trigger) {
      Cart.busy(true);
      if (trigger) trigger.disabled = true;

      return fetch(window.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: [SECTION] })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw data;
          Cart.render(data.sections[SECTION]);
        })
        .catch(Cart.handleError)
        .finally(function () { Cart.busy(false); });
    },

    quickAdd: function (variantId, trigger) {
      var original = trigger ? trigger.textContent : '';
      if (trigger) {
        trigger.disabled = true;
        trigger.textContent = 'Lägger till';
      }
      return Cart.addItems({ id: variantId, quantity: 1 }).catch(function (err) {
        Cart.handleError(err);
        if (trigger) {
          trigger.disabled = false;
          trigger.textContent = original;
        }
      });
    },

    addItems: function (payload) {
      Cart.busy(true);
      return fetch(window.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [payload], sections: [SECTION] })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw data;
          Cart.render(data.sections[SECTION]);
          Cart.open();
          return data;
        })
        .finally(function () { Cart.busy(false); });
    },

    /* Called by the product form. Accepts FormData. */
    add: function (formData, button) {
      var original = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Lägger till';
      }
      formData.append('sections', SECTION);

      return fetch(window.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw data;
          if (data.sections && data.sections[SECTION]) {
            Cart.render(data.sections[SECTION]);
          }
          Cart.open();
          return data;
        })
        .catch(function (err) {
          Cart.open();
          Cart.handleError(err);
        })
        .finally(function () {
          if (button) {
            button.disabled = false;
            button.textContent = original;
          }
        });
    }
  };


  /* ----------------------------------------------------------------------
     Product form + variant picker
     ---------------------------------------------------------------------- */
  function initProductForm() {
    $$('[data-product-form]').forEach(function (form) {
      var data = $('[data-variant-json]', form.closest('[data-product-root]') || document);
      var variants = data ? JSON.parse(data.textContent) : [];
      var idField = $('[name="id"]', form);
      var submit = $('[data-add-button]', form);
      var priceEl = $('[data-price]', form.closest('[data-product-root]') || document);
      var comparePriceEl = $('[data-compare-price]', form.closest('[data-product-root]') || document);

      function currentOptions() {
        return $$('.variant-picker input:checked', form.closest('[data-product-root]') || document).map(function (i) {
          return i.value;
        });
      }

      function sync() {
        if (!variants.length) return;
        var chosen = currentOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        });
        if (!match) return;

        idField.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (comparePriceEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            comparePriceEl.textContent = formatMoney(match.compare_at_price);
            comparePriceEl.hidden = false;
          } else {
            comparePriceEl.hidden = true;
          }
        }
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
        }
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url);
        }
      }

      $$('.variant-picker input').forEach(function (input) {
        input.addEventListener('change', sync);
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        Cart.add(new FormData(form), submit);
      });
    });
  }

  /* ----------------------------------------------------------------------
     Product gallery thumbs
     ---------------------------------------------------------------------- */
  function initGallery() {
    var main = $('[data-gallery-main]');
    if (!main) return;
    $$('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.dataset.full;
        main.srcset = '';
        $$('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ----------------------------------------------------------------------
     Cart page quantity steppers
     ---------------------------------------------------------------------- */
  function initCartPage() {
    $$('[data-cart-page] [data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input[name="updates[]"]');
        var next = Math.max(0, parseInt(input.value, 10) + parseInt(btn.dataset.qtyStep, 10));
        input.value = next;
        btn.closest('form').submit();
      });
    });
  }

  /* ----------------------------------------------------------------------
     UGC video tiles — play on view, tap to unmute
     ---------------------------------------------------------------------- */
  function initUgc() {
    var vids = $$('.ugc-tile video');
    if (!vids.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              var p = v.play();
              if (p) p.catch(function () {});
            } else {
              v.pause();
            }
          });
        },
        { threshold: 0.5 }
      );
      vids.forEach(function (v) { io.observe(v); });
    }

    $$('.ugc-tile__mute').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.parentElement.querySelector('video');
        v.muted = !v.muted;
        btn.setAttribute('aria-pressed', String(!v.muted));
      });
    });
  }

  /* ----------------------------------------------------------------------
     Rail arrows
     ---------------------------------------------------------------------- */
  function initRails() {
    $$('[data-rail-prev], [data-rail-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var rail = $('#' + btn.dataset.railTarget);
        if (!rail) return;
        var dir = btn.hasAttribute('data-rail-next') ? 1 : -1;
        rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initMobileNav();
    Cart.init();
    initProductForm();
    initGallery();
    initCartPage();
    initUgc();
    initRails();
  });

  window.themeCart = Cart;
})();
